import React from "react"
import { CenterSelectorNoAccess } from "../features/initiate/initNoAccess/CenterSelectorNoAccess"

function VarianceHome(){
    return <React.Fragment>
        <CenterSelectorNoAccess navigateTo='/varianceDashboard'/>
    </React.Fragment>
}

export {VarianceHome}